<dz-modal-header [hasBackdrop]="true">
	<h1 class="dz-text-28-extra-bold padding-bottom-4" dcrHTMLKey="MINI_COMPARE_DIALOG_TITLE">Compare Models</h1>
	<span *ngIf="routedFromHome" dcrHTMLKey="MINI_COMPARE_DIALOG_SUBTITLE"
		>NOTE: Changing allocations may result in the model no longer being aligned with the previously picked goal.</span
	>
</dz-modal-header>
<dz-modal-content class="text-align-center content gutter-space">
	<mb-mini-compare-dropdown
		*componentId="{ componentId: 'me.dropdown.families', ids: familiesId$ }; let res"
		[data]="res"
		[selectedModels]="selectedModelsList"
		[familiesData]="familiesData"
		(getSelectedFamilies)="onFamilyChange($event)"
		(familyListDropdown)="familyListDropdown = $event"
	></mb-mini-compare-dropdown>

	<div class="dz-grid">
		<div
			class="dz-row model-slider-container"
			[ngClass]="enableAddToCompareModel && selectedModelsList.length !== 3 ? ' dz-justify-content-center' : 'dz-justify-content-right'"
		>
			<div
				*ngFor="let model of selectedModelsList; let i = index"
				[ngClass]="
					selectedModelsList.length === applicationConstants.MAX_MODELS_FOR_COMPARISON || (enableAddToCompareModel && selectedModelsList.length !== 1)
						? 'dz-col-sm-6'
						: 'dz-col-sm-8'
				"
			>
				<mb-models-slider
					*componentId="{ componentId: 'me.models.slider', ids: familyIdsArray$[i] }; let res"
					[data]="res"
					[routedFromHome]="routedFromHome"
					[selectedModelId]="model.modelId"
					[selectedCardType]="model.exploreCardType"
					(modelChanged)="updateModel($event, i)"
					[selectedModelGroupId]="model.groupId"
				></mb-models-slider>
			</div>
		</div>
	</div>

	<div class="dz-grid">
		<div class="dz-row dz-justify-content-right allocation-chart-container">
			<div
				*ngFor="let model of selectedModelsList; let i = index"
				[ngClass]="
					selectedModelsList.length === applicationConstants.MAX_MODELS_FOR_COMPARISON || (enableAddToCompareModel && selectedModelsList.length !== 1)
						? 'dz-col-sm-6'
						: 'dz-col-sm-8'
				"
				class="chart-column"
			>
				<dz-icon *ngIf="enableAddToCompareModel && selectedModelsList.length === 3" type="times" clickable (click)="removeSelectedModel(i)" class="dz-pull-right"></dz-icon>
				<ng-template [componentId]="{ componentId: 'me.holdings.chart', ids: modelIdsArray$[i] }" let-result [loading]="chartSkeleton">
					<mb-model-allocation-chart [data]="result"></mb-model-allocation-chart>
				</ng-template>
				<ng-template #chartSkeleton>
					<mb-model-allocation-chartskeleton></mb-model-allocation-chartskeleton>
				</ng-template>
			</div>
			<div *ngIf="enableAddToCompareModel && selectedModelsList.length !== 3" [ngClass]="selectedModelsList.length !== 1 ? 'dz-col-sm-6' : 'dz-col-sm-8'">
				<mb-add-to-compare
					[selectedModels]="selectedModelsList"
					[familyList]="familyListDropdown"
					(getSelectedFamilyToCompare)="onFamilyChange($event)"
				></mb-add-to-compare>
			</div>
		</div>
	</div>
	<ng-template [componentId]="{ componentId: 'me.mini.compare', ids: selectedFamilyIds$ }" let-res [loading]="tableSkeleton">
		<mb-mini-compare-data-table
			[data]="res"
			[selectedPortfolios]="selectedModelsList"
			[showOptionalData]="showOptionalData"
			[loading]="tableSkeleton"
		></mb-mini-compare-data-table>
	</ng-template>
	<ng-template #tableSkeleton>
		<div class="dz-grid">
			<div class="dz-row" *ngFor="let row of GHOST_ROWS">
				<div class="dz-col-sm-8" *ngFor="let column of GHOST_COLUMNS">
					<ngx-skeleton-loader [theme]="{ width: '100%', 'border-radius': '0', height: '15px' }"></ngx-skeleton-loader>
				</div>
			</div>
		</div>
	</ng-template>
</dz-modal-content>
<!-- commented for now may need be added later on future decision -->
<!-- <div class="dz-row dz-modal-action-panel dz-modal-internal">
	<button class="dz-text-14-bold hover-pointer data-toggle-btn" (click)="showOptionalData = !showOptionalData">
		<dz-icon *ngIf="!showOptionalData" type="plus" class="color-blk-orange"></dz-icon>
		<dz-icon *ngIf="showOptionalData" type="minus" class="color-blk-orange"></dz-icon>
		<span class="padding-left-8" [dcrHTMLKey]="showOptionalData ? 'MINI_COMPARE_SHOW_LESS_DATA_LABEL' : 'MINI_COMPARE_SHOW_MORE_DATA_LABEL'">Show more</span>
	</button>
</div> -->
<dz-modal-actions [hasBackdrop]="true" align="between">
	<span class="dialog-disclosure pull-left text-condensed-12" dcrHTMLKey="MINI_COMPARE_DIALOG_DISCLOSURE">MINI_COMPARE_DIALOG_DISCLOSURE</span>
	<!-- added div to achieve space between alignment for disclosure and action buttons -->
	<div class="dz-flex">
		<button dz-button color="secondary" dcrHTMLKey="LAUNCH_FULL_ANALYSIS_BTN_TEXT" *ngIf="!disableLinkageTo360" (click)="onRedirectTo360()">Launch Full Analysis</button>
		<button
			dz-button
			dcrHTMLKey="HOW_TO_INVEST_BTN_TEXT"
			(click)="onRedirectToHowToInvest()"
			custom-tracking
			[track-event]="
				tealiumConstants.MODELS_EXPERIENCE_EVENTS.MODELS_EXPERIENCE_APP_NAME +
				':' +
				tealiumConstants.MODELS_EXPERIENCE_EVENTS.FIND_AND_COMPARE_PAGE +
				':mini compare modal:cta:how to invest'
			"
		>
			How to Invest
		</button>
	</div>
</dz-modal-actions>
